import { Component } from '@angular/core';

@Component({
  selector: 'app-business-builder',
  templateUrl: './business-builder.component.html',
  styleUrls: ['./business-builder.component.scss']
})
export class BusinessBuilderComponent {

}
